import { Button, ModalV2 } from '@skand/ui';

export interface CancellationModalProps {
  open: boolean;
  onSubmit: () => void;
  onCancel: () => void;
}

export const CancellationModal = ({ open, onCancel, onSubmit }: CancellationModalProps) => {
  return (
    <ModalV2 open={open}>
      <div className="mt-1 flex flex-col gap-6">
        <p className="color-neutral-800 typo-text-m">Unsaved Annotation</p>
        <p className="color-neutral-800 typo-text-s">
          This annotation hasn’t been saved. Leaving now will lose your progress.
        </p>
      </div>
      <div className="mt-4 w-full flex gap-2">
        <Button className="w-full cursor-pointer" onClick={onCancel} size="s">
          Don’t save
        </Button>
        <Button className="w-full cursor-pointer" filled onClick={onSubmit} primary size="s">
          Keep editing
        </Button>
      </div>
    </ModalV2>
  );
};
